import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  constructor(private http: HttpClient) {}
  public languageValueSet = new BehaviorSubject<any>(null);
  public languageValueCast = this.languageValueSet.asObservable();
  private languageChangeSubject = new BehaviorSubject<string | null>(null);
  public languageChange = this.languageChangeSubject.asObservable();

  updateLanguageState(language: string) {
    this.languageChangeSubject.next(language);
  }

  getLanguageFile(language: string): Observable<any> {
    return this.http.get(`assets/i18n/${language}.json`);
 }

 translateDropdownValues(dropdownValues: any[], languageFile: any): any[] {
  return dropdownValues.map(item => ({
    ...item,
    displayName: languageFile[item.value] || item.value
   }));
  }
}
